import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { PagingResponse } from '@/@types/responses/common/PagingResponse'
import { UserMessage } from '@/@types/messages/UserMessage'
import { MiscellaneousService } from './miscellaneous.service'
import { UserDetails } from '@/@types/responses/user/UserDetails'

export class UserService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public searchUsers(searchTerm: string, pageNumber: number, pageSize: number, sortField: string, ascending: boolean): Promise<PagingResponse<UserDetails>> {
    const queryString = `?searchTerm=${searchTerm}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&ascending=${ascending}`

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/users${queryString}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return new PagingResponse(json.pageNumber, json.pageSize, json.results.map((u: any) => new UserDetails(u)), json.totalResults)
    })
  }

  public updateUser(userId: string, userMessage: UserMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/users/${userId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
